import React from 'react';
import { ArrowRight, Clock, Shield } from 'lucide-react';
import { Button } from './ui/button';

export const CTASection = ({ onContactClick }) => {
  return (
    <section id="cta" className="py-20 bg-gradient-to-br from-[#3E2723] via-[#5D4037] to-[#3E2723] text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#8D6E63]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D7CCC8]/10 rounded-full blur-3xl"></div>
      
      <div className="max-w-5xl mx-auto px-4 md:px-8 relative z-10 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <Clock className="w-4 h-4" />
          <span className="text-sm font-medium">Limited Time Offer - Act Now!</span>
        </div>
        
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
          Protect Your Brand Today
        </h2>
        
        <p className="text-xl md:text-2xl mb-8 text-white/90 max-w-3xl mx-auto leading-relaxed">
          Don't risk losing your brand identity to competitors. Start your trademark registration process now and secure exclusive rights to your mark.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <Button
            onClick={onContactClick}
            className="bg-white text-[#3E2723] hover:bg-[#D7CCC8] px-8 py-6 text-lg font-semibold transition-all duration-300 hover:shadow-xl"
          >
            Register My Trademark
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
          <Button
            onClick={onContactClick}
            variant="outline"
            className="border-2 border-white text-white hover:bg-white hover:text-[#3E2723] px-8 py-6 text-lg font-semibold transition-all duration-300"
          >
            Get Free Consultation
          </Button>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="flex items-center justify-center gap-3">
            <Shield className="w-8 h-8 text-[#D7CCC8]" />
            <div className="text-left">
              <div className="font-bold text-lg">100% Secure</div>
              <div className="text-sm text-white/80">SSL Encrypted</div>
            </div>
          </div>
          <div className="flex items-center justify-center gap-3">
            <Clock className="w-8 h-8 text-[#D7CCC8]" />
            <div className="text-left">
              <div className="font-bold text-lg">Fast Process</div>
              <div className="text-sm text-white/80">Same-Day Filing</div>
            </div>
          </div>
          <div className="flex items-center justify-center gap-3">
            <Shield className="w-8 h-8 text-[#D7CCC8]" />
            <div className="text-left">
              <div className="font-bold text-lg">Money Back</div>
              <div className="text-sm text-white/80">Guarantee</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
